import { render, staticRenderFns } from "./OwnerIdeaPreviewPage.vue?vue&type=template&id=23e12092&scoped=true&"
import script from "./OwnerIdeaPreviewPage.vue?vue&type=script&lang=ts&"
export * from "./OwnerIdeaPreviewPage.vue?vue&type=script&lang=ts&"
import style0 from "./OwnerIdeaPreviewPage.vue?vue&type=style&index=0&id=23e12092&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e12092",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
